import React, { createContext, useState, useContext } from 'react';

// Importamos las traducciones
import translations from './translations';

// Creamos el contexto
const LanguageContext = createContext();

// Hook personalizado para usar el contexto de idioma
export const useLanguage = () => useContext(LanguageContext);

// Proveedor del contexto de idioma
export const LanguageProvider = ({ children }) => {
  // Estado para el idioma seleccionado, por defecto español
  const [language, setLanguage] = useState('ES');

  // Función para cambiar el idioma
  const changeLanguage = (lang) => {
    setLanguage(lang);
    // Opcionalmente, podríamos guardar la preferencia en localStorage
    localStorage.setItem('preferredLanguage', lang);
  };

  // Función para obtener una traducción específica
  const t = (key) => {
    // Si la clave no existe en las traducciones, devolvemos la clave como fallback
    if (!translations[language] || !translations[language][key]) {
      // Si existe en español, usamos esa como fallback
      if (translations['ES'] && translations['ES'][key]) {
        return translations['ES'][key];
      }
      return key;
    }
    return translations[language][key];
  };

  // Valor que proporcionará el contexto
  const value = {
    language,
    changeLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;